/* eslint-disable strict */

"use client";
import React from "react";
import { HttpLink, ApolloLink } from "@apollo/client";
import {
  ApolloNextAppProvider,
  ApolloClient,
  SSRMultipartLink,
  InMemoryCache,
} from "@apollo/client-integration-nextjs";

const createClient = (jwt: string | undefined) => {
  const httpLink = new HttpLink({
    uri: "/query",
    fetchOptions: { cache: "no-store" },
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${jwt}`,
    },
  });

  return new ApolloClient({
    cache: new InMemoryCache(),
    link:
      typeof window === "undefined"
        ? ApolloLink.from([
            new SSRMultipartLink({
              stripDefer: true,
            }),
            new HttpLink({
              uri: process.env.GRAPHQL_URL,
              fetchOptions: { cache: "no-store" },
              credentials: "include",
              headers: {
                authorization: `Bearer ${jwt}`,
                "Content-Type": "application/json",
              },
            }),
          ])
        : httpLink,
  });
};

export const WebshopApolloWrapper = ({
  children,
  jwt,
  clientName,
  hermesToken,
  hermesURL,
}: React.PropsWithChildren<{
  jwt: string | undefined;
  clientName?: string;
  hermesToken?: string;
  hermesURL?: string;
}>) => {
  const makeClient = React.useCallback(
    () => createClient(jwt),
    [clientName, hermesToken, hermesURL, jwt]
  );
  return (
    <ApolloNextAppProvider makeClient={makeClient}>
      {children}
    </ApolloNextAppProvider>
  );
};
